export class NotAuthenticatedError extends Error {
  constructor(message = 'you are not authenticated') {
    super(message)
    this.name = 'UnauthenticatedError'
  }
}

export class ApiError extends Error {
  public detail?: string
  constructor(public response: Response, detail?: string) {
    super(detail ?? `API呼び出しエラー`)
    this.name = 'ApiError'
    this.detail = detail
  }
}
